module.exports = __webpack_public_path__ + "img/barvaz_no.e3030fde.png";